module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_a-function.js
// module id = 46
// module chunks = 2 3 4 5 6 7 8 9 10 11 12